<template>
  <tool-advance-filter-content
    :contentInfo="contentInfo"
    :chartProperties="chartProperties"
    :chartData="chartGraphData"
    :isNotShowGraph="isNotShowGraph"
    :selectedComponent="selectedChartComponent"
    :addButtonText="addButtonText"
    :updateButtonText="updateButtonText"
    :headers="headers"
    :rows="rows"
    :singleHeading="singleHeading"
    :isShowHint="isShowHint"
    :infoText="infoText"
    :infoError="infoError"
    :emptyChartMessage="emptyChartMessage"
    :focusElementName="focusElementName"
    :gridButtonTemplate="gridButtonTemplate"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    :baselineTitle="baselineRow ? baselineRow.title : ''"
    :headerbaseline="baselineHeader"
    :rowsbaseline="baselineRow ? baselineRow.rows : []"
    :emptyGridData="emptyGridData"
    :rowOuterButton="rowOuterButton"
    @addRow="addRow"
    @editableRowButtonClick="genericMethodClick"
    @setFocusOnRowElement="setFocusOnRowElement"
    @GridSelectionChange="AddNewTypeRow"
    :rowTemplateButton="rowTemplateButton"
    @rowTemplateButtonClick="genericMethodClick"
    @OuterRowButtonClick="genericMethodClick"
    @onChange="OnOptionChange"
    @removeRow="removeRow"
    @onChangeChartTab="onChangeChartTab"
  ></tool-advance-filter-content>
</template>
<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { AdvanceInvestmentFilter, DATETYPE } from "../../helpers/constant";
import { InvestmentAdvanceFilterContent } from "../../mixin";
import {
  GET_SELECTED_INVESTMENT_INFORMATION,
  GET_INVESTMENT_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters } from "vuex";
import { RepaymentOptionList } from "../../helpers/constant";
import _ from "lodash";

export default {
  props: {
    baselineData: {
      type: Object,
    },
  },
  components: { ToolAdvanceFilterContent },
  computed: {
    ...mapGetters("investment", {
      selectedInvestmentData: GET_SELECTED_INVESTMENT_INFORMATION,
      getInvestmentInformation: GET_INVESTMENT_INFORMATION,
    }),
    legendItems() {
      return ["Base Contribution", "Contribution Adjustments"];
    },
    gridButtonTemplate() {
      let difference = true;
      let Investments = this.getInvestmentInformation.filter(
        (sr) => sr.investmentGuid == this.selectedInvestmentData.investmentGuid
      );
      let ExistingData = Investments[0].advancedetails
        .filter((sr) => sr.typeId == AdvanceInvestmentFilter.Contribution)
        .map(function (t) {
          let p = {};
          p.amount = t.amount;
          p.index = t.index;
          p.frequency = t.frequency;
          p.description = t.description;
          p.startDate = t.startDate;
          p.startDateType = t.startDateType.toString();
          p.endDate = t.endDate;
          p.endDateType = t.endDateType.toString();
          return p;
        });

      let CurrentDataObject = [];
      if (this.rows)
        for (let i = 0; i < this.rows.length; i++) {
          if (ExistingData.length > 0)
            CurrentDataObject.push({
              amount: this.rows[i].amount.value,
              index: this.rows[i].index.value,
              frequency: this.rows[i].frequency.value,
              description: this.rows[i].description.value,
              startDate: this.rows[i].startDate.value,
              startDateType: this.rows[i].startDateType.value.toString(),
              endDate: this.rows[i].endDate.value,
              endDateType: this.rows[i].endDateType.value.toString(),
            });
          else {
            if (
              !this.validatebyrow(this.rows[i], this.rows[i].subTypeId.value)
            ) {
              difference = false;
              break;
            }
          }
        }
      if (ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }
      this.enableResetButton(difference, "UpdateGraph");
      this.enableResetButton(difference, "reset");

      return this.gridButtonTemplatedata;
    },
  },
  mixins: [InvestmentAdvanceFilterContent],
  mounted() {
    this.RemapGraphsModel();
  },
  data() {
    return {
      emptyGridData: {
        title: "Click to add Additional Contribution",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },

      rowOuterButton: [
        // {
        //   icon: "trash",
        //   size: "large",
        //   variation: "icon-only",
        //   text: "Add New",
        //   callBackMethod: "DeleteSubtype",
        //   isdisabled: false,
        //   key: "deletesubtype",
        // },
      ],
      focusElementName: "",
      timeSeriesChartData: this.getTimeSeriesCoordinate(
        this.baselineData.advancedetails,
        AdvanceInvestmentFilter.Contribution,
        this.baselineData.projectionYear
      ),
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add New",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],
      gridButtonTemplatedata: [
        {
          icon: "eye",
          size: "medium",
          variation: "primary",
          text: "Update Graph",
          callBackMethod: "UpdateGraph",
          isdisabled: false,
          key: "UpdateGraph",
        },
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],

      emptyChartMessage: {
        message: "Add Drawdown details to create a chart.",
        btnTxt: "",
      },
      contentInfo: {
        heading: "Contribution",
        subHeading:
          "You can enter in contribution details at different time periods.",
        infoAlert: {
          title: "Important note",
          variation: "informational",
          text: "You can enter in contribution details at different time periods.",
        },
      },
      updateButtonText: "Update Graph",
      addButtonText: "Add new",
      isShowHint: true,
      infoText: ["Hit 'Tab' to move to the next cell and add a new row"],
      singleHeadingOptions: [
        {
          key: 1,
          value: "Regular",
          fields: [
            "amount",
            "index",
            "frequency",

            "startDate",

            "endDate",
            "description",
          ],
          overlapvalidations: false,
        },
        {
          key: 2,
          value: "Lump Sum",
          fields: ["amount", "startDate", "description"],
          overlapvalidations: false,
          showDateLabel: true,
        },
      ],
      singleHeadingButtonText: "",
      gridSplitId: "subTypeId",

      infoError: false,
      singleHeading: "Contribution Adjustment",
      headers: [
        {
          type: "FormatInput",
          label: "Amount",
          cols: 1,
          key: "amount",
          isAllowOnlyNumber: true,
          appendText: "",
          currencyFormat: "$,",
          validation: false,
          max: 999999999,
          length: 9,
          style: {
            width: "160px",
            overflow: "visible",
          },
        },
        {
          type: "Dropdown",
          label: "Index",
          cols: 1,
          key: "index",
          options: this.indexOptions(),
          defaultValue: "AWOTE",
          validation: true,
        },
        {
          type: "Dropdown",
          label: "Frequency",
          cols: 2,
          key: "frequency",
          options: this.frequencyOption(),
          defaultValue: "Weekly",
          validation: true,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: false,
          typing: true,
          label: "Start",
          text: "Date",
          cols: 1,
          key: "startDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          showLeft: true,
          typing: true,
          label: "End",
          cols: 1,
          key: "endDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,
          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Input",
          label: "Description",
          placeholder: "e.g Change in Rates",
          isAllowToAddNextRow: true,
          cols: 1,
          Option: "",
          key: "description",
          length: 200,
        },

        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "50px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: this.fillGrid(),
      baselineHeader: this.getEditBaselineHeader(),
      baselineRow: {
        title: "Baseline Contribution",
        rows: [
          {
            contributionAmount: {
              value: this.baselineData.contributionAmount,
            },
            durationTypeId: {
              value: this.baselineData.durationTypeId,
            },
          },
        ],
      },
    };
  },

  async created() {},
  beforeMount() {
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceInvestmentFilter.Contribution
    );
  },
  beforeDestroy() {
    this.fillInvestmentModel(AdvanceInvestmentFilter.Contribution);
    this.validations(
      this.baselineFilterObject.advancedetails,
      AdvanceInvestmentFilter.Contribution
    );
  },
  methods: {
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },

    reset() {
      let Loans = this.getInvestmentInformation.filter(
        (sr) => sr.investmentGuid == this.selectedInvestmentData.investmentGuid
      );
      let selectedRepData = Loans[0].advancedetails.filter(
        (sr) => sr.typeId == AdvanceInvestmentFilter.Contribution
      );
      if (selectedRepData.length > 0) {
        let advanceData = [];
        for (let i = 0; i < selectedRepData.length; i++) {
          advanceData.push({
            subTypeId: {
              value: selectedRepData[i].subTypeId,
            },
            // EffectiveAsON: {
            //   value: selectedRepData[i].effectiveAsON,
            // },

            amount: {
              value: selectedRepData[i].amount,
            },
            index: {
              value: selectedRepData[i].index,
            },
            frequency: {
              value: selectedRepData[i].frequency,
            },
            startDate: {
              value: selectedRepData[i].startDate,
              disable:
                selectedRepData[i].startDateType != DATETYPE.Other
                  ? true
                  : false,
            },
            startDateType: {
              value: selectedRepData[i].startDateType,
            },
            endDate: {
              value: selectedRepData[i].endDate,
              disable:
                selectedRepData[i].endDateType != DATETYPE.Other ? true : false,
            },
            endDateType: {
              value: selectedRepData[i].endDateType,
            },
            description: {
              value: selectedRepData[i].description,
            },
            typeId: {
              value: AdvanceInvestmentFilter.Return,
            },
          });
        }
        this.rows = advanceData;
      } else {
        this.rows = [];
        this.getinsertEmptyRows(this.rows);
      }
      this.enableResetButton(false, "reset");
    },
    async UpdateGraph() {
      this.areaChartData = [];
      this.barChartData = [];
      this.fillInvestmentModel(AdvanceInvestmentFilter.Contribution);
      if (
        !this.validations(
          this.baselineFilterObject.advancedetails,
          AdvanceInvestmentFilter.Contribution
        )
      ) {
        await this.UpdateGraphModel();
        this.timeSeriesChartData = this.getTimeSeriesCoordinate(
          this.baselineFilterObject.advancedetails,
          AdvanceInvestmentFilter.Contribution,
          this.baselineData.projectionYear
        );
        this.onChangeChartTab(this.selectedTabComponent);
      }
    },

    getUserInputData(userInputRows) {
      let addtionalData = [];
      let rows = Object.assign([], userInputRows);
      rows = this.ResetMonthPickerValue(rows);
      for (let i = 0; i < rows.length; i++) {
        if (!this.validatebyrow(rows[i], rows[i].subTypeId.value)) {
          addtionalData.push({
            amount: {
              value: rows[i].amount.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].amount.disable,
            },
            index: {
              value: rows[i].index.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].index.disable,
            },
            frequency: {
              value: rows[i].frequency.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].frequency.disable,
            },
            startDateType: {
              value: rows[i].startDateType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDateType.disable,
            },
            startDate: {
              value: rows[i].startDate.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].startDate.disable,
            },
            endDateType: {
              value: rows[i].endDateType.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDateType.disable,
            },
            endDate: {
              value: rows[i].endDate.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].endDate.disable,
            },
            description: {
              value: rows[i].description.value,
              IsError: false,
              ErrorText: [],
              disable: rows[i].description.disable,
            },
            typeId: {
              value: AdvanceInvestmentFilter.Contribution,
              IsError: false,
              ErrorText: [],
            },
            subTypeId: {
              value: rows[i].subTypeId.value,
              IsError: false,
              ErrorText: [],
            },
            newRow: false,
          });
        }
      }
      return addtionalData;
    },
    setFocusOnRowElement() {
      this.focusElementName = this.headers[0].key + "0";
    },
    fillData(data, subtypeid) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? DATETYPE.Other
        : data.startDateType.value;
      let endDateType = IsDataundfined
        ? 0
        : data.endDateType.value == 0
        ? DATETYPE.Other
        : data.endDateType.value;
      let emptyObject = {
        amount: {
          value: IsDataundfined ? "0" : data.amount.value,
          IsError: IsDataundfined ? false : data.amount.IsError,
          ErrorText: IsDataundfined ? [] : data.amount.ErrorText,
          disable: IsDataundfined ? false : data.amount.disable,
        },
        index: {
          value: IsDataundfined ? 0 : data.index.value,
          IsError: IsDataundfined ? false : data.index.IsError,
          ErrorText: IsDataundfined ? [] : data.index.ErrorText,
          disable: IsDataundfined ? false : data.index.disable,
        },
        frequency: {
          value: IsDataundfined ? 0 : data.frequency.value,
          IsError: IsDataundfined ? false : data.frequency.IsError,
          ErrorText: IsDataundfined ? [] : data.frequency.ErrorText,
          disable: IsDataundfined ? false : data.frequency.disable,
        },
        startDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        startDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,
          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        endDateType: {
          value: IsDataundfined ? 0 : data.endDateType.value,
          IsError: IsDataundfined ? false : data.endDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.endDateType.ErrorText,
          disable: IsDataundfined ? false : data.endDateType.disable,
        },
        endDate: {
          value: IsDataundfined ? "" : data.endDate.value,
          IsError: IsDataundfined ? false : data.endDate.IsError,
          ErrorText: IsDataundfined ? [] : data.endDate.ErrorText,
          text:
            IsDataundfined || data.endDate.value == ""
              ? ""
              : this.startOptionsNew().filter((x) => x.value == endDateType)[0]
                  .text,
        },
        description: {
          value: IsDataundfined ? "" : data.description.value,
          IsError: IsDataundfined ? false : data.description.IsError,
          ErrorText: IsDataundfined ? [] : data.description.ErrorText,
          disable: IsDataundfined ? false : data.description.disable,
        },
        subTypeId: {
          value: IsDataundfined ? subtypeid : data.subTypeId.value,
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },
    fillGrid() {
      let gridRows = [];
      if (this.baselineData.advancedetails != null) {
        let data = this.baselineData.advancedetails.filter(
          (sr) => sr.typeId.value == AdvanceInvestmentFilter.Contribution
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
        //this.getinsertEmptyRows(gridRows);
      }
      return gridRows;
    },

    getEditBaselineHeader() {
      return [
        {
          type: "Input",
          label: "Contribution",
          currencyFormat: "$,",
          appendText: "",
          key: "contributionAmount",
          isAllowOnlyNumber: true,
          class: "",
          length: 5,
          cols: 4,
          isdisabled: true,
          isEditiable: true,
        },
        {
          type: "Input",
          label: "Frequency",
          key: "durationTypeId",
          options: RepaymentOptionList,
          class: "",
          cols: 4,
          isdisabled: true,
          isEditiable: true,
        },

        {
          type: "EditButton",
          label: "Edit",
          variation: "flat",
          key: "edit",
          icon: "pencil",
          class: "flexiblePosition",
          cols: 4,
          isdisabled: false,
          align: "center",
          callBackMethod: "editBaseLineButton_Click",
        },
      ];
    },
    editBaseLineButton_Click() {
      this.baselineHeader = [
        {
          type: "Input",
          label: "Contribution",
          currencyFormat: "$,",
          appendText: "",
          key: "contributionAmount",
          isAllowOnlyNumber: true,
          length: 9,
          max: 999999999,
          class: "",
          cols: 4,
          isdisabled: false,
        },
        {
          type: "Dropdown",
          label: "Frequency",
          key: "durationTypeId",
          options: RepaymentOptionList,
          class: "",
          cols: 4,
          isdisabled: false,
        },
        {
          type: "Button",
          label: "Save",
          variation: "primary",
          key: "save",
          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "saveBaseLineButton_Click",
        },
        {
          type: "Button",
          label: "Cancel",
          variation: "flat",
          key: "cancel",
          class: "shrink",
          cols: 1,
          isdisabled: false,
          callBackMethod: "cancelBaseLineButton_Click",
        },
      ];
    },
    saveBaseLineButton_Click(data) {
      if (
        this.baselineFilterObject.contributionAmount !=
          data[0].contributionAmount.value ||
        this.baselineFilterObject.durationTypeId != data[0].durationTypeId.value
      ) {
        this.enableResetButton(false, "UpdateGraph");
      }
      this.baselineFilterObject.contributionAmount =
        data[0].contributionAmount.value;
      this.baselineFilterObject.durationTypeId = data[0].durationTypeId.value;

      this.$emit("resetBaselineData", this.baselineFilterObject);
      this.cancelBaseLineButton_Click();
    },
    cancelBaseLineButton_Click() {
      this.baselineRow.rows[0].durationTypeId.value =
        this.baselineFilterObject.durationTypeId;
      this.baselineRow.rows[0].contributionAmount.value =
        this.baselineFilterObject.contributionAmount;

      this.baselineHeader = this.getEditBaselineHeader();
    },
  },
};
</script>
<style lang="scss" module></style>
